/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_EndInputs */

const en_entity_end = /** @type {(inputs: Entity_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

const de_entity_end = /** @type {(inputs: Entity_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende`)
};

/**
* | output |
* | --- |
* | "End" |
*
* @param {Entity_EndInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_end = /** @type {((inputs?: Entity_EndInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_EndInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_end(inputs)
	return de_entity_end(inputs)
});